import React from "react";
import { objToFormData } from "../../../helpers/FormHelper";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { createCategory, fetchCategories } from "../../../actions/sticker_maker/categoriesActions";
import { setNewParams, setNewError } from "../../../store/sticker_maker/categoriesSlice";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";
import { AVAILABLE_LOCALES_EXTEND } from "../../../configs/constants";

const New = () => {
  const dispatch  = useAppDispatch();
  const newParams = useAppSelector(state => state.stickerMaker.categories.newParams);
  const error     = useAppSelector(state => state.stickerMaker.categories.newError);

  let params: any = { ...newParams };

  if (params) {
    params.name_translations  = {};
    params.empty_locales      = Object.keys(AVAILABLE_LOCALES_EXTEND);
  }

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function getLocaleRules() {
    const localeRules: any = {};
    Object.keys(AVAILABLE_LOCALES_EXTEND).forEach(key => localeRules[key] = { blank: false });

    return localeRules;
  }

  function onFinish(data: object) {
    const rules     = { name_translations: getLocaleRules() };
    const formData  = objToFormData(data, rules);
    handleSave(formData).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createCategory(data));

    if (createCategory.fulfilled.match(resultAction)) {
      dispatch(fetchCategories({ target: params?.target }));
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!newParams}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-skin'>
        <h6 className="v-content-label">Create Category</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form onFinish={onFinish} params={params} />
      </div>
    </DrawerRight>
  )
}

export default New;
